import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Card, Col, Tab, Tabs } from "react-bootstrap";

const displayMessage = (data) => {
  return data.map((element, index) => (
    <React.Fragment key={index}>
      <a href={element.link}>{element.title}</a>
      <br></br>
    </React.Fragment>
  ));
};

const GNSSDegradationEventsCard = ({ innerRef, data }) => {
  return (
    <React.Fragment>
      <Card.Title as="h6" ref={innerRef}>
        GNSS degradation events
      </Card.Title>
      <Card.Body>
        <Tabs
          defaultActiveKey="GPS NANU"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="GPS NANU" title="GPS NANU">
            <Col md={{ span: 10, offset: 1 }}>
              <code>
                {data?.gpsNanu?.length > 0
                  ? displayMessage(data.gpsNanu)
                  : "No active GPS NANU for the reporting period"}
              </code>
            </Col>
          </Tab>
          <Tab eventKey="GLONASS NAGU" title="GLONASS NAGU">
            <Col md={{ span: 10, offset: 1 }}>
              <code>
                {data?.gloNagu?.length > 0
                  ? displayMessage(data.gloNagu)
                  : "No active GLONASS NAGU for the reporting period"}
              </code>
            </Col>
          </Tab>
          <Tab eventKey="Galileo NAGU" title="Galileo NAGU">
            <Col md={{ span: 10, offset: 1 }}>
              <code>
                {data?.galNagu?.length > 0 > 0
                  ? displayMessage(data.galNagu)
                  : "No active Galileo NAGU for the reporting period"}
              </code>
            </Col>
          </Tab>
        </Tabs>
      </Card.Body>
    </React.Fragment>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <GNSSDegradationEventsCard innerRef={ref} {...props} />
  ))
);
